/**
 *
 * Asynchronously loads the component for SupplierManagement
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SupplierManagement = lazyLoad(() => import('./index'));
